import React, { useState, createContext } from "react";
import ScrollToTop from "react-scroll-to-top";

import Sidebar from "./Components/Sidebar/Sidebar";
import About from "./Components/About/About";
import TechStack from "./Components/TechStack/TechStack";
import Projects from "./Components/Projects/Projects";
import Contact from "./Components/Contact/Contact";
import "./App.css";
import NavbarMobileVeiw from "./Components/Sidebar/NavbarMobileveiw";

export const ThemeContext = createContext(null);

const App = () => {
  const [theme, setTheme] = useState("dark");

  const changeTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };
  return (
    <ThemeContext.Provider value={{ theme, changeTheme }}>
      <div id={theme}>
        <NavbarMobileVeiw />
        <Sidebar changeTheme={changeTheme} theme={theme} />
        <About />
        <TechStack />
        <Projects />
        <Contact />
      </div>

      <ScrollToTop
        top="200"
        smooth
        height="20"
        width="20"
        color="white"
        style={{ borderRadius: "90px ", backgroundColor: "#38004c" }}
      />
    </ThemeContext.Provider>
  );
};

export default App;
